import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

export type TipoOperacao = 'completo' | 'mercadinho' | 'lanchonete' | 'oficina' | 'salao' | 'distribuidora'

export interface EmpresaInfo {
  id: number
  razao_social: string
  tipo_operacao: TipoOperacao
  [k: string]: any
}

export function useEmpresaAtual() {
  return useQuery<EmpresaInfo>({
    queryKey: ['empresa-atual'],
    queryFn: async () => (await api.get('/empresa/atual')).data,
    staleTime: 60_000,
  })
}

export function useTipoOperacao(): TipoOperacao {
  const { data } = useEmpresaAtual()
  return (data?.tipo_operacao as TipoOperacao) || 'completo'
}

/** Retorna true se o tipo eh simplificado (sem NF obrigatoria) */
export function useIsSimplificado(): boolean {
  const tipo = useTipoOperacao()
  return ['mercadinho', 'lanchonete', 'oficina', 'salao'].includes(tipo)
}
